import { useEffect, useState } from 'react'

// Simple string hash for deterministic color selection
const hashString = (str) => {
  let h = 0
  for (let i = 0; i < str.length; i++) h = (Math.imul(31, h) + str.charCodeAt(i)) | 0
  return Math.abs(h)
}

const DesktopIcon = ({ icon, name, appName, onOpenApp, color }) => {
  const handleRightClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const contextMenuEvent = new CustomEvent('showContextMenu', {
      detail: { event: e, type: 'desktop-icon', data: { appName } }
    })
    document.dispatchEvent(contextMenuEvent)
  }

  return (
    <div 
      className="desktop-icon flex flex-col items-center w-20 text-center icon-hover select-none cursor-pointer" 
      onClick={() => onOpenApp(appName)}
      onContextMenu={handleRightClick}
    >
      <div className="p-3 rounded-xl glass-effect transition-all duration-200 shadow-md hover:shadow-lg">
        <i className={`${icon} text-3xl drop-shadow-sm`} style={{ color }}></i>
      </div>
      <span 
        className="text-xs mt-1.5 px-2 py-0.5 rounded-full text-white/95 font-medium tracking-wide bg-black/40 backdrop-blur-md border border-white/10 shadow-sm leading-tight max-w-[88px] truncate"
        style={{ textShadow: '0 1px 2px rgba(0,0,0,0.6)' }}
      >
        {name}
      </span>
    </div>
  )
}

const DesktopIcons = ({ onOpenApp }) => {
  const [theme, setTheme] = useState(localStorage.getItem('pp_icon_theme') || 'neon')
  const [userColor, setUserColor] = useState(localStorage.getItem('pp_icon_user_color') || '#f472b6')
  
  // Listen for theme changes
  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.id) setTheme(e.detail.id)
      if (e.detail?.color) setUserColor(e.detail.color)
    }
    window.addEventListener('iconThemeChange', handler)
    return () => window.removeEventListener('iconThemeChange', handler)
  }, [])

  const palettes = {
    pinkPixel: ['#f472b6', '#ec4899', '#db2777', '#be185d', '#9d174d'],
    cloudwerx: ['#38bdf8', '#0ea5e9', '#0284c7', '#0369a1', '#075985'],
    monotone: ['#ffffff'],
    neon: ['#ff00ff', '#00eaff', '#39ff14', '#fffb00', '#ff007f'],
    pastel: ['#fbcfe8', '#bfdbfe', '#fde68a', '#c7d2fe', '#bbf7d0'],
    rainbow: ['#ef4444', '#f59e0b', '#eab308', '#10b981', '#3b82f6', '#6366f1', '#db2777'],
    userColor: [userColor]
  }
  const palette = palettes[theme] || palettes.neon
  
  // Deterministic color by name
  const colorForName = (name, offset = 0) => {
    if (!palette.length) return '#ffffff'
    const h = hashString(name + ':' + offset)
    return palette[h % palette.length]
  }

  const icons = [
    { base: 'fas fa-folder', name: 'Files', appName: 'explorer' },
    { base: 'fas fa-globe', name: 'Browser', appName: 'browser' },
    { base: 'fas fa-terminal', name: 'Terminal', appName: 'terminal' },
    { base: 'fas fa-shopping-bag', name: 'Catalog', appName: 'store' },
    { base: 'fas fa-images', name: 'Photos', appName: 'photos' },
    { base: 'fas fa-th', name: 'Apps', appName: 'apps' },
    { base: 'fas fa-gamepad', name: 'Games', appName: 'games' },
  ]

  return (
    <div className="absolute top-0 left-0 p-6 grid gap-6">
      {icons.map((iconData, index) => {
        const color = colorForName(iconData.appName)
        return (
            <DesktopIcon 
              key={`${index}-${theme}`}
              icon={`${iconData.base}`}
              name={iconData.name}
              appName={iconData.appName}
              onOpenApp={onOpenApp}
              color={color}
            />
        )
      })}
    </div>
  )
}

export default DesktopIcons